/**
 * @file guid.js
 *
 * Unique ID for an element or function
 * @type {Number}
 * @private
 */
"use strict";

exports.__esModule = true;
exports.newGUID = newGUID;
var _guid = 1;

/**
 * Get the next unique ID
 *
 * @return {String} 
 * @function newGUID
 */

function newGUID() {
  return _guid++;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9qcy91dGlscy9ndWlkLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBT0EsSUFBSSxLQUFLLEdBQUcsQ0FBQyxDQUFDOzs7Ozs7Ozs7QUFRUCxTQUFTLE9BQU8sR0FBRztBQUN4QixTQUFPLEtBQUssRUFBRSxDQUFDO0NBQ2hCIiwiZmlsZSI6InNyYy9qcy91dGlscy9ndWlkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBAZmlsZSBndWlkLmpzXG4gKlxuICogVW5pcXVlIElEIGZvciBhbiBlbGVtZW50IG9yIGZ1bmN0aW9uXG4gKiBAdHlwZSB7TnVtYmVyfVxuICogQHByaXZhdGVcbiAqL1xubGV0IF9ndWlkID0gMTtcblxuLyoqXG4gKiBHZXQgdGhlIG5leHQgdW5pcXVlIElEXG4gKlxuICogQHJldHVybiB7U3RyaW5nfSBcbiAqIEBmdW5jdGlvbiBuZXdHVUlEXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBuZXdHVUlEKCkge1xuICByZXR1cm4gX2d1aWQrKztcbn1cbiJdfQ==